import { MapTo } from '@adobe/aem-react-editable-components';
import TermsAndConditions, { TermsAndConditionsEditConfig } from './TermsAndConditions';


export default MapTo('cob-corp-acquisition/components/creditonebank/terms-and-conditions')(TermsAndConditions, TermsAndConditionsEditConfig);